








import { Component, Vue, Prop } from 'nuxt-property-decorator'
import CurrentDestionation from './current-destination.vue'
import TagComponent from './tag-component/index.vue'
import SearchHistory from './search-history.vue'

@Component({
  components: {
    TagComponent,
    SearchHistory,
    CurrentDestionation
  }
})
export default class TourHomeSearchMain extends Vue {
  @Prop() tagList: any
  @Prop() currentDestinationInfo: any
  @Prop() visible!: boolean
}
